import React from 'react';

export const preventDefault = (event: React.MouseEvent) => {
    event.stopPropagation();
    event.preventDefault();
};
